<div class="dropdown__nav mx-auto mt-4 rounded-lg bg-white drop-shadow-2" data-testid="dropdown_nav">
  <ul class="py-2">
    <ng-content></ng-content>
  </ul>
</div>
